import { HiArrowNarrowLeft, HiArrowNarrowRight, HiOutlineChevronLeft, HiOutlineChevronRight, HiDocumentDownload } from 'react-icons/hi';
// eslint-disable-next-line
import { paginateType } from 'utils/proptypes';
import { useEffect, useState } from 'react';
import { defaultpageCount } from 'utils/constants';
import { Button } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import './paginate.scss';

const PaginateTable = (props: paginateType) => {
  const { setCurrentPage, currentPage, totalEntities, isLoadingTable, pageCount = defaultpageCount, isShowDownload = false, exportHandler } = props;
  const [t] = useTranslation();
  const totalPage = Math.ceil(totalEntities / pageCount) ?? 1;
  const [inputPage, setInputPage] = useState(currentPage + 1)

  const handleNextPage = () => {
    if (currentPage < totalPage - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);

    }
  };
  const changePage = (event: any) => {
    setInputPage(event.target.value)
  }

  const handlecChangePage = (event: any) => {
    if (event.key === 'Enter' && event.target.value <= totalPage && event.target.value > 0) {
      setCurrentPage(event.target.value - 1)
    }
  }

  useEffect(() => {
    setInputPage(currentPage + 1)
  }, [currentPage])

  return (
    <>
      <div className='flex paginate w-full bottom-5 text-xs'>
        <div className='w-1/2 flex mr-2 justify-end paginate-button h-34'>
          <div className="w-auto flex-row gap-2 ml-3 bg-gray-400 rounded-sm previous-button-container">
            <button
              disabled={isLoadingTable}
              onClick={() => handlePreviousPage()}
              data-testid="test-button-previous"
              className="previous-button w-auto border text-gray-900 rounded-sm border-gray-200 bg-white text-xs font-normal cursor-pointer focus:ring-4 focus:ring-blue-300 focus:!ring-2 group flex h-min w-fit items-center justify-center text-center focus:z-10"
            >
              <HiArrowNarrowLeft className='w-5 h-5 mr-2' />
              {t('paginate.previousPage')}
            </button>
          </div>
          <div className="w-auto  flex-row gap-2 ml-3 bg-gray-400 rounded-sm">
            <button
              disabled={isLoadingTable}
              onClick={() => handleNextPage()}
              data-testid="test-button-next"
              className="next-button w-auto text-white text-xs font-normal cursor-pointer focus:ring-4 focus:ring-blue-300 focus:!ring-2 group flex h-min w-fit items-center justify-center text-center focus:z-10"
            >
              {t('paginate.nextPage')}
              <HiArrowNarrowRight className='w-5 h-5 ml-2' />
            </button>
          </div>
        </div>
        <div className='w-1/2 flex justify-end second-paginate' data-testid="test-pagination">
          <form onSubmit={(e) => e.preventDefault()}>
            <input type="number" max={totalPage} min="1" className='border paginate-input bg-gray-50 w-14 text-gray-900 text-center text-xs' value={inputPage} onChange={changePage} onKeyPress={handlecChangePage} />
          </form>

          <p className='flex items-center mx-3 text-center text-on-primary-containerpt-1'>of {totalPage}</p>
          <div className='flex justify-center bg-gray-100'>
            <div className='w-8 paginate-icon flex justify-center items-center cursor-pointer mr-1'
              onClick={() => handlePreviousPage()}>
              <HiOutlineChevronLeft className='w-5 h-5 text-on-primary-container' />
            </div>
            <div className='w-8 paginate-icon flex justify-center items-center cursor-pointer'
              onClick={() => handleNextPage()}>
              <HiOutlineChevronRight className='w-5 h-5 text-on-primary-container' />
            </div>
          </div>
          {isShowDownload && (
            <Button size="sm" color="gray" onClick={() => exportHandler?.()}>
              <HiDocumentDownload size={16} className="mr-2" />
              <p>{t('download')}</p>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
export default PaginateTable;
